import AudioTrackList from './audio-track-list';
import VideoTrackList from './video-track-list';
import TextTrackList from './text-track-list';
import HtmlTrackElementList from './html-track-element-list';
import TextTrack from './text-track';
import AudioTrack from './audio-track';
import VideoTrack from './video-track';
import HTMLTrackElement from './html-track-element';
import mergeOptions from '@emav-util/merge-options';
var NORMAL = {
    audio: {
        ListClass: AudioTrackList,
        TrackClass: AudioTrack,
        capitalName: 'Audio'
    },
    video: {
        ListClass: VideoTrackList,
        TrackClass: VideoTrack,
        capitalName: 'Video'
    },
    text: {
        ListClass: TextTrackList,
        TrackClass: TextTrack,
        capitalName: 'Text'
    }
};
Object.keys(NORMAL).forEach(function (type) {
    NORMAL[type].getterName = ''.concat(type, 'Tracks');
    NORMAL[type].privateName = ''.concat(type, 'Tracks_');
});
var REMOTE = {
    remoteText: {
        ListClass: TextTrackList,
        TrackClass: TextTrack,
        capitalName: 'RemoteText',
        getterName: 'remoteTextTracks',
        privateName: 'remoteTextTracks_'
    },
    remoteTextEl: {
        ListClass: HtmlTrackElementList,
        TrackClass: HTMLTrackElement,
        capitalName: 'RemoteTextTrackEls',
        getterName: 'remoteTextTrackEls',
        privateName: 'remoteTextTrackEls_'
    }
};
var ALL = mergeOptions(NORMAL, REMOTE);
REMOTE.names = Object.keys(REMOTE);
NORMAL.names = Object.keys(NORMAL);
ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
export {
    NORMAL,
    REMOTE,
    ALL
};